import {computed, pluralize, computedFn} from '@api'
import {ui, IUser, CatalogViewMode, CatalogStore, deployments} from '@stores'

export class StringsStore {
  constructor() {
  }

  @computed get zoomOut() { return 'Zoom Out'}

  @computed get zoomIn() { return 'Zoom In'}

  @computed get notFound() { return 'Not Found' }

  @computed get pasteImages() { return 'Paste Image(s)' }

  @computed get publish() {
    return 'Publish'
  }

  @computed get applied() {
    return 'Applied'
  }


  @computed get new() {
    switch (ui.language) {
      case 'zh-hans':
      default:
        return 'New'
    }
  }

  @computed get showSwatches() {
    switch (ui.language) {
      case 'zh-hans':
      default:
        return 'Group Swatches'
    }
  }

  @computed get showHeroCards() {
    switch (ui.language) {
      case 'zh-hans':
      default:
        return 'Hero Cards'
    }
  }

  @computed get presets() {
    switch (ui.language) {
      case 'zh-hans':
      default:
        return 'Presets'
    }
  }

  @computed get loadingMoreGroups() {
    switch (ui.language) {
      case 'zh-hans':
      default:
        return 'Loading More...'
    }
  }

  @computed get loadMoreGroups() {
    switch (ui.language) {
      case 'zh-hans':
      default:
        return 'Load More'
    }
  }

  @computed get applyToAllGroups() {
    switch (ui.language) {
      case 'zh-hans':
      default:
        return 'Apply to all groups'
    }
  }

  @computed get toggleCardView() {
    switch (ui.language) {
      case 'zh-hans':
      default:
        return 'Toggle Table View'
    }
  }

  @computed get modifiedItems() {
    switch (ui.language) {
      case 'zh-hans':
      default:
        return 'Modified Items'
    }
  }

  @computed get item() {
    switch (ui.language) {
      case 'zh-hans':
        return '项'

      default:
        return 'item'
    }
  }
  @computed get unassignedOnly() {
    switch (ui.language) {
      case 'zh-hans':
        return '仅显示未组货配色'

      default:
        return 'Unassigned Only?'
    }
  }

  @computed get existing() {
    switch (ui.language) {
      case 'zh-hans':

      default:
        return 'existing'
    }
  }

  @computed get sibling() {
    switch (ui.language) {
      case 'zh-hans':
      default:
        return 'sibling'
    }
  }

  @computed get target() {
    switch (ui.language) {
      case 'zh-hans':
      default:
        return 'target'
    }
  }

  @computed get cannotAssign() {
    switch (ui.language) {
      case 'zh-hans':
      default:
        return 'cannot assign'
    }
  }

  @computed get hasAlreadyBeenAssigned() {
    switch (ui.language) {
      case 'zh-hans':
      default:
        return 'has already been assigned'
    }
  }

  @computed get overwriteExisting() {
    switch (ui.language) {
      case 'zh-hans':
      default:
        return 'Overwrite existing'
    }
  }

  @computed get valueAlreadyAssigned() {
    switch (ui.language) {
      case 'zh-hans':
      default:
        return 'Value is Already Assigned'
    }
  }

  @computed get viewInLibrary() {
    switch (ui.language) {
      default:
        return 'View in Library'
    }
  }

  @computed get numberOfColumns() {
    switch (ui.language) {
      default:
        return 'Number of Columns'
    }
  }

  @computed get fullWidth() {
    switch (ui.language) {
      default:
        return 'Full-Width'
    }
  }

  @computed get fullHeight() {
    switch (ui.language) {
      default:
        return 'Full-Height'
    }
  }

  @computed get singleLineOfProductCards() {
    switch (ui.language) {
      default:
        return `Single-Row`
    }
  }

  @computed get groupedColumnView() {
    switch (ui.language) {
      default:
        return 'Grouped Column View'
    }
  }

  @computed get yes() {
    switch (ui.language) {
      default:
        return 'yes'
    }
  }

  @computed get no() {
    switch (ui.language) {
      default:
        return 'no'
    }
  }

  @computed get loadingSecondaries() {
    switch (ui.language) {
      default:
        return 'Loading Secondaries...'
    }
  }
  @computed get select() {
    switch (ui.language) {
      default:
        return 'Select'
    }
  }
  @computed get downloadImage() {
    switch (ui.language) {
      default:
        return `Download Image`
    }
  }
  @computed get ok() {
    switch (ui.language) {
      default:
        return `OK`
    }
  }

  @computed get accessDenied() {
    switch (ui.language) {
      default:
        return `Access Denied`
    }
  }

  @computed get loadingSeasons() {
    switch (ui.language) {
      default:
        return `Loading seasons`
    }
  }

  @computed get showInlineGroupAggregation() {
    switch (ui.language) {
      default:
        return 'Show Inline Aggregation Details'
    }
  }

  @computed get showGroupAggregations() {
    switch (ui.language) {
      default:
        return 'Aggregations'
    }
  }

  @computed get showGroupAggregationsWhenCollapsed() {
    switch (ui.language) {
      default:
        return 'Show All Aggregations'
    }
  }

  @computed get showAggregatesInSidebar() {
    switch (ui.language) {
      default:
        return 'Sidebar Aggregations'
    }
  }

  @computed get showEmptyGroups() {
    switch (ui.language) {
      default:
        return 'Show Empty Groups'
    }
  }

  noResultsFoundFor = (searchText: string) => `${this.noResults} found${searchText ? ` for '${searchText}'` : ''}`

  @computed get noResults() {
    switch (ui.language) {
      case 'zh-hans':
      default: {
        return `No Results`
      }
    }
  }

  @computed get noDataAvailableForSection() {
    switch (ui.language) {
      case 'zh-hans':
      default: {
        return `No data available in this section.`
      }
    }
  }

  @computed get noSecondariesDataAvailable() {
    switch (ui.language) {
      case 'zh-hans':
      default: {
        return `No secondaries data available.`
      }
    }
  }
  @computed get importUser() : Partial<IUser> {
    switch (ui.language) {
      default:
        return {name: 'System Administrator', shortName: 'SA'}
    }
  }

  @computed get systemUser() {
    return {}[ui.language] ?? 'System User'
  }

  @computed get reply() {
    return {}[ui.language] ?? 'Reply'
  }

  nChildren = computedFn((n: number) => {
    switch (ui.language) {
      default:
        return n == 0 ? 'No Replies' : n == 1 ? '1 Reply' : `${n} children`
    }
  })

  @computed get save() {
    return {}[ui.language] ?? 'save'
  }

  @computed get saveChanges() {
    return {}[ui.language] ?? 'Save Changes'
  }

  @computed get editComment() {
    return {}[ui.language] ?? 'Edit Comment'
  }

  @computed get deleteComment() {
    return {}[ui.language] ?? 'Delete Comment'
  }

  @computed get postComment() {
    return {}[ui.language] ?? 'Post Comment'
  }

  commentOnThisCatalogItem = (catalog: CatalogStore) => {
    return `Comment on this ${catalog.catalogItemName}`
  }

  @computed get createComment() {
    return {}[ui.language] ?? 'Create Comment'
  }

  @computed get photoVideo() {
    return {}[ui.language] ?? 'Photo/Video'
  }

  @computed get noComments() {
    return {}[ui.language] ?? 'There are no comments for this item.'
  }

  @computed get noChangeHistory(){
    return {}[ui.language] ?? 'There is no change history for this item. '
  }

  @computed get intentionallyBlank() {
    return {}[ui.language] ?? 'This space intentionally left blank.'
  }

  @computed get account() {
    return {
             'zh-hans': '账号'
           }[ui.language] ?? 'Account'
  }

  @computed get specLibraries() {
    return {
             'zh-hans': '规格库'
           }[ui.language] ?? 'Spec Libraries'
  }

  @computed get mercOptionsLibraries() {
    return {
             'zh-hans': '库'
           }[ui.language] ?? 'Libraries'
  }

  @computed get activities() {
    return {
             'zh-hans': '活动'
           }[ui.language] ?? 'Activities'
  }

  @computed get comments() {
    return {
             'zh-hans': '备注'
           }[ui.language] ?? 'Comments'
  }

  @computed get notes() { return {'zh-hans': '注释'}[ui.language] ?? 'Notes'}

  @computed get activeChip() { return {'zh-hans': '可用'}[ui.language] ?? 'Active'}

  @computed get carryover() { return {'zh-hans': '沿用'}[ui.language] ?? 'Carryover'}

  @computed get listView() { return {'zh-hans': '列表视图'}[ui.language] ?? 'List View'}

  @computed get cardView() { return {'zh-hans': '卡片视图'}[ui.language] ?? 'Card View'}

  @computed get tableView() { return {'zh-hans': '????'}[ui.language] ?? 'Table View'}

  @computed get toggleSort() { return {'zh-hans': '切换排序'}[ui.language] ?? 'Toggle Sort'}

  @computed get loading() { return {'zh-hans': '加载中'}[ui.language] ?? 'Loading'}

  @computed get add() { return {'zh-hans': '添加'}[ui.language] ?? 'Add'}

  @computed get edit() { return {'zh-hans': '编辑'}[ui.language] ?? 'Edit'}

  @computed get duplicate() { return {'zh-hans': '复制'}[ui.language] ?? 'Duplicate'}

  @computed get delete() { return {'zh-hans': '删除'}[ui.language] ?? 'Delete'}

  @computed get viewAll() { return {'zh-hans': '查看全部'}[ui.language] ?? 'View All'}

  @computed get updatePlmSpecTitle() { return {'zh-hans': '替换现有数据'}[ui.language] ?? 'Replace Existing Data'}

  @computed get openInC8() { return {'zh-hans': '在C8中查看'}[ui.language] ?? 'See it in C8'}

  @computed get loadMore() { return {'zh-hans': '加载\n更多'}[ui.language] ?? `Load\nMore`}

  @computed get noImage() { return {'zh-hans': '没有\n图片'}[ui.language] ?? 'No\nImage'}

  @computed get previousGroup() { return {'zh-hans': '前一组'}[ui.language] ?? 'Previous Group'}

  @computed get nextGroup() { return {'zh-hans': '后一组'}[ui.language] ?? 'Next Group'}

  @computed get clear() {
    return {
             'zh-hans': '明确'
           }[ui.language] ?? 'Clear'
  }

  @computed get clearGroups() {
    switch (ui.language) {
      case 'zh-hans':
        return '取消分组'
      default: {
        return 'Clear Groups'
      }
    }
  }

  @computed get addGroup() {
    switch (ui.language) {
      default: {
        return 'Add Group'
      }
    }
  }
  @computed get chooseLanguage() {
    return {
             'zh-hans': '选择语言'
           }[ui.language] ?? 'Choose Language'
  }

  renderingCatalog = (catalog: CatalogStore) => {
    const {emptyLabel} = this
    return {
             'zh-hans': `加载 ${pluralize(catalog?.catalogItemName === emptyLabel ? '项' : catalog?.catalogItemName)}...`
           }[ui.language] ?? `Loading ${pluralize(catalog?.catalogItemName === emptyLabel ? 'item' : catalog?.catalogItemName)}...`
  }

  @computed get clearSelection() { return {'zh-hans': '取消选择'}[ui.language] ?? `Clear Selection`}

  @computed get toggleInlineDetails() { return {'zh-hans': '更多细节'}[ui.language] ?? 'Inline Details'}

  @computed get uploadToC8() { return {'zh-hans': '发布'}[ui.language] ?? 'Publish to C8'}

  @computed get offlineItems() { return {'zh-hans': '离线多项'}[ui.language] ?? 'Pending Items'}

  @computed get offlineItem() { return {'zh-hans': '离线项'}[ui.language] ?? 'Pending Item'}

  @computed get autoplay() { return {'zh-hans': '自动前进'}[ui.language] ?? 'Auto Advance'}

  @computed get gridView() { return {'zh-hans': '网格视图'}[ui.language] ?? 'Grid View'}

  @computed get presentationMode() { return {'zh-hans': '演示模式\n(P)'}[ui.language] ?? 'Presentation Mode\n(P)'}

  @computed get itemAlignment() { return { 'zh-hans': '项目对齐' }[ui.language] ?? 'Item Alignment' }

  @computed get loadingWorkspaces() { return {'zh-hans': '工作空间加载中...'}[ui.language] ?? 'Loading Workspaces...'}

  @computed get goToLibrary() { return {'zh-hans': '打开库'}[ui.language] ?? 'Go to library'}

  @computed get goToWorkspace() { return {'zh-hans': '打开库'}[ui.language] ?? 'Go to Workspace'}

  @computed get catalogActions() { return {'zh-hans': '目录操作'}[ui.language] ?? 'Catalog Actions'}

  @computed get perspectives() { return {'zh-hans': '透视图'}[ui.language] ?? 'Perspectives'}

  @computed get seasonalHierarachies() { return {'zh-hans': '季节层级'}[ui.language] ?? 'Seasonal Hierarchies'}

  @computed get cardFields() { return {'zh-hans': '卡片字段'}[ui.language] ?? 'Card Fields'}

  @computed get groupByActions() { return {'zh-hans': '按操作分组'}[ui.language] ?? 'Group By Actions'}

  @computed get libraries() { return {'zh-hans': '库'}[ui.language] ?? 'Libraries'}

  @computed get workspaces() { return {'zh-hans': '工作空间'}[ui.language] ?? 'Workspaces'}

  @computed get itemDetails() { return {'zh-hans': '显示小方框'}[ui.language] ?? 'Item Details'}

  @computed get switchingWorkspaces() { return {'zh-hans': '切换工作空间...'}[ui.language] ?? 'Switching workspace...'}

  @computed get loadingGroups() { return {'zh-hans': '分组加载中...'}[ui.language] ?? 'Loading groups...'}

  toggleActive = (catalog: CatalogStore, isActive: any, includeCatalogItemName: boolean) => {
    switch (ui.language) {
      case 'zh-hans': {
        return isActive ? '切换至停用' : '切换至可用'
      }
      default: {
        const extra = includeCatalogItemName ? ` ${catalog.catalogItemName}` : ''
        return isActive ? `Deactivate ${extra}` : `Activate ${extra}`
      }
    }
  }

  cannotAddProduct_Perspective = (catalog: CatalogStore) => {
    switch (ui.language) {
      case 'zh-hans': {
        return `不能创建 '${catalog.catalogItemName}'\n禁止设置透视图`
      }
      default: {
        return `Cannot create '${catalog.catalogItemName}'\nPerspective must not be set`
      }
    }
  }

  @computed get previousCatalogItem() {
    switch (ui.language) {
      case 'zh-hans': {
        return `前一项`
      }
      default: {
        return `Previous Item`
      }
    }
  }

  @computed get nextCatalogItem() {
    switch (ui.language) {
      case 'zh-hans': {
        return `后一项`
      }
      default: {
        return `Next Item`
      }
    }
  }

  addProduct = (catalog: CatalogStore) => {
    switch (ui.language) {
      // case 'zh-hans': {
      //   return `后一项`
      // }

      default: {
        return `Add ${catalog.catalogItemName}`
      }
    }
  }

  addProductWithImage = (catalog: CatalogStore) => {
    switch (ui.language) {
      case 'zh-hans': {
        return `${this.addProduct(catalog)} 和图片`
      }

      default: {
        return `${this.addProduct(catalog)} with Image`
      }
    }
  }

  addProductsWithImages = (catalog: CatalogStore) =>{
    switch (ui.language) {
      case 'zh-hans': {
        return `${this.addProducts(catalog)} 和图片`
      }

      default: {
        return `${this.addProducts(catalog)} from Images`
      }
    }
  }

  addProducts = (catalog: CatalogStore) => {
    switch (ui.language) {
      case 'zh-hans': {
        return `创建 ${catalog.catalogItemName}s`
      }

      default: {
        return `Add ${catalog.catalogItemName}s`
      }
    }
  }

  @computed get addTagType() { return {'zh-hans': '添加标签类型'}[ui.language] ?? 'Add Tag Type'}

  @computed get addTag() { return {'zh-hans': '添加标签'}[ui.language] ?? 'Add Tag'}

  @computed get editTag() { return {'zh-hans': '编辑标签'}[ui.language] ?? 'Edit Tag'}

  @computed get syncTag() { return {'zh-hans': '同步标签'}[ui.language] ?? 'Sync Tags'}

  @computed get createTag() { return {'zh-hans': '创建新标签'}[ui.language] ?? 'Create New Tag'}

  @computed get collapseAll() { return {'zh-hans': '全部折叠'}[ui.language] ?? 'Collapse All'}

  @computed get expandAll() { return {'zh-hans': '全部展开'}[ui.language] ?? 'Expand All'}

  @computed get more() { return {'zh-hans': '更多'}[ui.language] ?? 'More'}

  @computed get dropImageHere() { return {'zh-hans': '图片拖至此处'}[ui.language] ?? 'Drop Image Here'}

  @computed get addProductsWithImage() { return {'zh-hans': '给产品添加图片'}[ui.language] ?? 'Add Products With Image'}

  @computed get remove() { return {'zh-hans': '移除'}[ui.language] ?? 'Remove'}
  
  @computed get removeSort() { return {'zh-hans': '移除'}[ui.language] ?? 'Remove Sort'}

  @computed get changeLog() { return {'zh-hans': '??'}[ui.language] ?? 'Change Log'}

  @computed get cannotCreateSpecification() { return {'zh-hans': '无法创建产品规格 - 需要先选择“分类2”（Category2）'}[ui.language] ?? 'Cannot Create Specification - Requires Category2 to be selected'}

  @computed get addSpecification() { return {'zh-hans': '添加产品规格'}[ui.language] ?? 'Add Specification'}

  @computed get addSpecifications() { return {'zh-hans': '添加多个产品规格'}[ui.language] ?? 'Add Specifications'}

  @computed get removeAssignedItemMsg() {
    return {'zh-hans': '所选项已经分配给产品，你是否确定要将其从当前季移除？该项仍然分配给指定产品。'}[ui.language] ?? 'Selected Item has assigned product(s)  are you sure to remove it from current season? Item will be still assigned to the products.'
  }

  @computed get actualDeleteItemMsg() { return {'zh-hans': '删除该项会将其从分配的产品上移除，你确定要删除吗？'}[ui.language] ?? 'Deleting selected Item would also remove it from the assigned product(s)  are you sure to delete it?'}

  @computed get deleteAssignedItemMsg() {
    return {'zh-hans': '所选项已经分配给产品，你是否确定要将其从当前季移除？该项仍然分配给指定产品。'}[ui.language] ?? 'Selected Item has an assigned product(s)  are you sure to delete it? Deleting the item will not remove it from the product(s).'
  }

  @computed get requiresCat2() { return {'zh-hans': '需要“分类2”（Category 2）'}[ui.language] ?? 'Requires Category 2'}

  @computed get active() { return {'zh-hans': '可用'}[ui.language] ?? 'Active'}

  @computed get inactive() { return {'zh-hans': '停用'}[ui.language] ?? 'Inactive'}

  @computed get search() { return {'zh-hans': '搜索'}[ui.language] ?? 'Search'}

  @computed get manageLibrary() { return {'zh-hans': 'n管理库'}[ui.language] ?? 'Manage Library'}

  @computed get open() { return {'zh-hans': '关闭'}[ui.language] ?? 'Open'}

  @computed get close() { return {'zh-hans': '关闭'}[ui.language] ?? 'Close'}

  @computed get toggleSidebar() { return {'zh-hans': '切换侧边栏'}[ui.language] ?? 'Toggle Sidebar'}

  @computed get go() { return {'zh-hans': '返'}[ui.language] ?? 'Go'}

  @computed get goBack() { return {'zh-hans': '返回'}[ui.language] ?? 'Go Back'}

  @computed get moreActions() { return {'zh-hans': '更多操作'}[ui.language] ?? 'More Actions'}

  @computed get filters() { return {'zh-hans': '过滤'}[ui.language] ?? 'Filters'}

  @computed get filter() { return {'zh-hans': '过滤'}[ui.language] ?? 'Filter'}

  attributes = (catalog: CatalogStore) => {
    return {'zh-hans': '属性'}[ui.language] ?? `${catalog.catalogItemName} Attributes`
  }

  @computed get seasonalLibraries() { return {'zh-hans': '库'}[ui.language] ?? 'Libraries'}

  @computed get productAttributes() { return {'zh-hans': '产品属性'}[ui.language] ?? 'Product Attributes'}

  @computed get draggingRequiresCategory2() { return {'zh-hans': '需要“分类2”（Category 2）进行拖拽'}[ui.language] ?? 'Dragging requires Category 2'}

  @computed get siteLibrary() { return {'zh-hans': '站点库'}[ui.language] ?? 'site-library'}

  @computed get seasonalLibrary() { return {'zh-hans': '季节库'}[ui.language] ?? 'seasonal-library'}

  @computed get seasonalTag() { return {'zh-hans': '季节的'}[ui.language] ?? 'seasonal'}

  @computed get siteTag() { return {'zh-hans': '站点'}[ui.language] ?? 'site'}

  @computed get unassign() { return {'zh-hans': '未分配'}[ui.language] ?? 'Unassign'}

  @computed get unassigned() { return {'zh-hans': '未分配'}[ui.language] ?? 'Unassigned'}

  @computed get emptyLabel() { return {'zh-hans': ''}[ui.language] ?? '--'}

  @computed get noValue() { return {'zh-hans': '(没有值)'}[ui.language] ?? ('(No Value)')}

  @computed get sidebarSubtitleLabel() { return {'zh-hans': '季节'}[ui.language] ?? 'Season'}

  @computed get images() { return {'zh-hans': '??'}[ui.language] ?? 'image'}

  @computed get placeholderText() {
    return 'Lorem ipsum dolor sit amet  consectetur adipiscing elit  sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam  quis nostrud' +
           ' exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident  sunt in culpa qui officia deserunt mollit anim id est laborum.'
  }

  @computed get fullscreenImage() { return {'zh-hans': '全屏'}[ui.language] ?? 'Full-Screen'}

  @computed get removeImageFromCarousel() { return {'zh-hans': '移除图片'}[ui.language] ?? 'Remove Image'}

  disableRemoveImage = (catalog: CatalogStore) => {
    return {'zh-hans': '非可用板，不能移除图片'}[ui.language] ?? `Image does not belong to ${catalog.catalogItemName}`
  }

  @computed get imageDeleteMessage() { return {'zh-hans': '你确定要删除这张图片吗？'}[ui.language] ?? 'Are you sure you want to delete this image?'}

  @computed get imageDropMessage() { return {'zh-hans': '你确定要上传这张图片吗？'}[ui.language] ?? 'Are you sure you want to upload this image?'}

  @computed get imageReorderMessage() { return {'zh-hans': '你确定要对图片位置重新排序吗？'}[ui.language] ?? 'Are you sure you want to reorder this image to position'}

  @computed get noMerchProductVersionAvailable() { return {'zh-hans': '无企划商品可用'}[ui.language] ?? 'No merch product version available'}

  @computed get tagDelete() { return {'zh-hans': '你确定要删除这个标签吗？'}[ui.language] ?? 'Are you sure you want to delete this tag?'}

  levelOfDetail = computedFn((levelOfDetail: number) => {
    switch (ui.language) {
      case 'zh-hans': {
        return levelOfDetail == 1 ? '更少细节' : '更多细节'
      }

      default: {
        return levelOfDetail == 1 ? 'Less Detail' : 'More Detail'
      }
    }
  })

  addCatalogItem = (catalog: CatalogStore) => {
    return _.capitalize(`${this.add} ${_.capitalize(pluralize(catalog.catalogItemName, 1))}`)
  }

  @computed get groupBy() {
    switch (ui.language) {
      case 'zh-hans': {
        return `分组`
      }

      default: {
        return `Group By`
      }
    }
  }

  @computed get viewOptions() {
    switch (ui.language) {
      case 'zh-hans': {
        return `视图设置`
      }

      default: {
        return `View Options`
      }
    }
  }

  librariesTitle = computedFn((title: string) => {
    switch (ui.language) {
      case 'zh-hans': {
        return `${title} ‘库`
      }

      default: {
        return `${title} Libraries`
      }
    }
  })

  attributesTitle = computedFn((title: string) => {
    switch (ui.language) {
      case 'zh-hans': {
        return `${title} '属性`
      }

      default: {
        return `${title} Attributes`
      }
    }
  })

  searchFilters = computedFn((library?: string) => {
    switch (ui.language) {
      case 'zh-hans': {
        return `搜索过滤条件...`
      }

      default: {
        return !library ? `Search...` : `Search ${pluralize(_.capitalize(library))}...`
      }
    }
  })

  @computed get all() {
    switch (ui.language) {
      case 'zh-hans': {
        return `全部`
      }

      default: {
        return `All`
      }
    }
  }

  @computed get noFiltersSearchFound() {
    switch (ui.language) {
      case 'zh-hans': {
        return `未找到搜索的过滤条件`
      }

      default: {
        return `No filters found with the applied search`
      }
    }
  }

  @computed get negativeFilter() {
    switch (ui.language) {
      // case 'zh-hans': {
      // }

      default: {
        return `Exclude results with this value`
      }
    }

  }
  @computed get noFilterFound() {
    switch (ui.language) {
      case 'zh-hans': {
        return `无过滤条件`
      }

      default: {
        return `No filters found`
      }
    }
  }

  @computed get toggleQRCode() {
    switch (ui.language) {
      case 'zh-hans': {
        return `切换二维码`
      }

      default: {
        return 'Toggle QR Code'
      }
    }
  }

  @computed get showLabel() {
    switch (ui.language) {
      case 'zh-hans': {
        return `显示标签`
      }

      default: {
        return 'Show Label'
      }
    }
  }

  @computed get showSelectedFirst() {
    switch (ui.language) {
      case 'zh-hans':
      default: {
        return 'Show Selected First'
      }
    }
  }

  @computed get disabledDragging() {
    switch (ui.language) {
      case 'zh-hans':
      default: {
        return 'Dragging will be Disabled'
      }
    }
  }

  @computed get showCardLabel() {
    switch (ui.language) {
      case 'zh-hans': {
        return `显示标签`
      }

      default: {
        return 'Show Card Label'
      }
    }
  }

  @computed get cardSizeL1() {
    switch (ui.language) {
      case 'zh-hans': {
        return `卡片大小（1级）`
      }

      default: {
        return 'Card Size (Level 1)'
      }
    }
  }

  @computed get cardSizeL2() {
    switch (ui.language) {
      case 'zh-hans': {
        return `卡片大小（2级）`
      }

      default: {
        return 'Card Size (Level 2)'
      }
    }
  }

  @computed get resetCustomOrder() {
    switch (ui.language) {
      case 'zh-hans': {
        return `重置自定义顺序`
      }

      default: {
        return 'Reset Custom Order'
      }
    }
  }

  @computed get default() {
    switch (ui.language) {
      case 'zh-hans': {
        return `默认`
      }

      default: {
        return 'Default'
      }
    }
  }

  @computed get none() {
    switch (ui.language) {
      case 'zh-hans': {
        return `没有`
      }

      default: {
        return 'None'
      }
    }
  }

  @computed get cardSizeLabel() {
    switch (ui.language) {
      case 'zh-hans': {
        return `卡片大小：`
      }

      default: {
        return 'Card Size:'
      }
    }
  }

  @computed get cardSizeTooltip() {
    switch (ui.language) {
      case 'zh-hans': {
        return `卡片大小`
      }

      default: {
        return 'Card Size'
      }
    }
  }

  @computed get cardSizeResetTooltip() {
    switch (ui.language) {
      case 'zh-hans': {
        return `重置卡片大小`
      }

      default: {
        return 'Reset Card Size'
      }
    }
  }

  @computed get imageRatio() {
    switch (ui.language) {
      case 'zh-hans': {
        return `图像比率`
      }

      default: {
        return 'Image Ratio'
      }
    }
  }

  @computed get auto() {
    switch (ui.language) {
      case 'zh-hans':
      default: {
        return 'Auto'
      }
    }
  }

  @computed get square() {
    switch (ui.language) {
      case 'zh-hans': {
        return `正方形`
      }

      default: {
        return 'Square'
      }
    }
  }

  @computed get portrait() {
    switch (ui.language) {
      case 'zh-hans': {
        return `纵向`
      }

      default: {
        return 'Portrait'
      }
    }
  }

  @computed get landscape() {
    switch (ui.language) {
      case 'zh-hans': {
        return `横向`
      }

      default: {
        return 'Landscape'
      }
    }
  }

  @computed get hierarchy() {
    switch (ui.language) {
      case 'zh-hans':
      default: {
        return 'Seasonal Hierarchy'
      }
    }
  }

  @computed get specifications() {
    switch (ui.language) {
      case 'zh-hans': {
        return `规格`
      }

      default: {
        return 'Library Specifications'
      }
    }
  }

  @computed get showInModal() {
    switch (ui.language) {
      case 'zh-hans': {
        return `在对话框中显示`
      }

      default: {
        return 'Show in Modal'
      }
    }
  }

  @computed get showDetailsInSidebar() {
    switch (ui.language) {
      case 'zh-hans': {
        return `在侧边栏显示`
      }

      default: {
        return 'Show in Sidebar'
      }
    }
  }

  @computed get showOnlyExpandedCards() {
    switch (ui.language) {
      case 'zh-hans': {
        return `仅显示展开的卡片`
      }

      default: {
        return 'Show Only Expanded Cards'
      }
    }
  }

  @computed get showExpandedCardsFirst() {
    switch (ui.language) {
      case 'zh-hans': {
        return `优先显示展开的卡片`
      }

      default: {
        return 'Show Expanded Cards First'
      }
    }
  }

  @computed get collapseCards() {
    switch (ui.language) {
      case 'zh-hans': {
        return `折叠卡片`
      }

      default: {
        return 'Collapse Cards'
      }
    }
  }

  @computed get showOnlyExpandedGroups() {
    switch (ui.language) {
      case 'zh-hans': {
        return `仅显示展开的分组`
      }

      default: {
        return 'Show Only Expanded Groups'
      }
    }
  }

  switchViewMode = computedFn((viewMode: 'card' | 'table' | 'pivot') => {
    switch (ui.language) {
      case 'zh-hans': {
        return `视图`
      }

      default: {
        return `Switch to ${viewMode == 'card' ? 'Table' : 'Card'} View`
      }
    }
  })

  @computed get stackView() {
    switch (ui.language) {
      case 'zh-hans': {
        return `缩略视图`
      }

      default: {
        return 'Stack View'
      }
    }
  }

  @computed get stackGroups() {
    switch (ui.language) {
      case 'zh-hans': {
        return `缩略组`
      }

      default: {
        return 'Stack Groups'
      }
    }
  }

  @computed get flatMode() {
    switch (ui.language) {
      case 'zh-hans': {
        return `平铺模式`
      }

      default: {
        return 'Flat Mode'
      }
    }
  }

  @computed get sortBy() {
    switch (ui.language) {
      case 'zh-hans': {
        return `排序`
      }

      default: {
        return 'Sort By'
      }
    }
  }

  @computed get ascending() {
    switch (ui.language) {
      case 'zh-hans': {
        return `升序`
      }

      default: {
        return 'Ascending'
      }
    }
  }

  @computed get descending() {
    switch (ui.language) {
      case 'zh-hans': {
        return `降序`
      }

      default: {
        return 'Descending'
      }
    }
  }

  @computed get alphabetical() {
    switch (ui.language) {
      case 'zh-hans': {
        return '字母顺序'
      }

      default: {
        return 'Alphabetical'
      }
    }
  }

  @computed get custom() {
    switch (ui.language) {
      case 'zh-hans': {
        return `自定义`
      }

      default: {
        return 'Custom'
      }
    }
  }

  @computed get clearFilters() {
    switch (ui.language) {
      case 'zh-hans': {
        return `清除过滤条件`
      }

      default: {
        return 'Clear Filters'
      }
    }
  }

  @computed get toggleExpandCollapse() {
    switch (ui.language) {
      case 'zh-hans': {
        return `切换展开/折叠`
      }

      default: {
        return 'Toggle Expand/Collapse'
      }
    }
  }

  @computed get pivotView() {
    switch (ui.language) {
      case 'zh-hans': {
        return `数据透视图`
      }

      default: {
        return 'Pivot View'
      }
    }
  }

  @computed get reportView() {
    switch (ui.language) {
      case 'zh-hans':
      default: {
        return 'Report View'
      }
    }
  }

  @computed get loadingMoreItems() {
    switch (ui.language) {
      case 'zh-hans': {
        return `加载更多项`
      }

      default: {
        return 'Loading More Items'
      }
    }
  }

  @computed get aggregateDetails() {
    switch (ui.language) {
      case 'zh-hans': {
        return `汇总详细信息`
      }

      default: {
        return 'Aggregate Details'
      }
    }
  }

  @computed get modifyGrouping() {
    switch (ui.language) {
      case 'zh-hans': {
        return `修改分组`
      }

      default: {
        return 'Modify Grouping'
      }
    }
  }

  @computed get levelofDetailLabel() {
    switch (ui.language) {
      case 'zh-hans': {
        return `细节显示等级`
      }

      default: {
        return 'Level of Detail'
      }
    }
  }

  @computed get showQRCode() {
    switch (ui.language) {
      case 'zh-hans': {
        return `显示二维码`
      }

      default: {
        return 'Show QR Code'
      }
    }
  }

  @computed get collapseGroups() {
    switch (ui.language) {
      case 'zh-hans': {
        return `折叠分组`
      }

      default: {
        return 'Collapse Groups'
      }
    }
  }

  @computed get groupLoading() {
    switch (ui.language) {
      case 'zh-hans': {
        return `分组加载中...`
      }

      default: {
        return 'Group is Loading...'
      }
    }
  }

  @computed get expand() {
    switch (ui.language) {
      case 'zh-hans': {
        return `展开`
      }

      default: {
        return 'Expand'
      }
    }
  }

  @computed get collapse() {
    switch (ui.language) {
      case 'zh-hans': {
        return `折叠`
      }

      default: {
        return 'Collapse'
      }
    }
  }

  @computed get expandGroups() {
    switch (ui.language) {
      case 'zh-hans': {
        return `展开分组`
      }

      default: {
        return 'Expand Groups'
      }
    }
  }

  @computed get creating() {
    switch (ui.language) {
      case 'zh-hans': {
        return `创建中...`
      }

      default: {
        return 'Creating...'
      }
    }
  }

  @computed get addLevel() {
    switch (ui.language) {
      case 'zh-hans': {
        return `添加层级`
      }

      default: {
        return 'Add Level'
      }
    }
  }

  @computed get sortDescending() {
    switch (ui.language) {
      case 'zh-hans': {
        return `分类 ${this.descending}`
      }

      default: {
        return `Sort ${this.descending}`
      }
    }
  }

  @computed get sortAscending() {
    switch (ui.language) {
      case 'zh-hans': {
        return `分类 ${this.ascending}`
      }

      default: {
        return `Sort ${this.ascending}`
      }
    }
  }

  @computed get show() {
    switch (ui.language) {
      case 'zh-hans': {
        return `显示`
      }

      default: {
        return 'show'
      }
    }
  }

  @computed get hide() {
    switch (ui.language) {
      case 'zh-hans': {
        return `隐藏`
      }

      default: {
        return 'hide'
      }
    }
  }

  @computed get details() {
    switch (ui.language) {
      case 'zh-hans': {
        return `详细信息`
      }

      default: {
        return 'details'
      }
    }
  }

  @computed get switchTo() {
    switch (ui.language) {
      case 'zh-hans': {
        return `切换到`
      }

      default: {
        return 'Switch to'
      }
    }
  }

  @computed get view() {
    switch (ui.language) {
      case 'zh-hans': {
        return `视图`
      }

      default: {
        return 'View'
      }
    }
  }

  @computed get addImage() {
    switch (ui.language) {
      case 'zh-hans': {
        return `添加图片`
      }

      default: {
        return `Add Image`
      }
    }
  }

  @computed get syncing() {
    switch (ui.language) {
      case 'zh-hans': {
        return `同步中...`
      }

      default: {
        return `Syncing...`
      }
    }
  }

  @computed get syncNow() {
    switch (ui.language) {
      case 'zh-hans': {
        return `立即同步`
      }

      default: {
        return `Sync Now`
      }
    }
  }

  @computed get never() {
    switch (ui.language) {
      case 'zh-hans': {
        return `从不`
      }

      default: {
        return `Never`
      }
    }
  }

  @computed get drillDown() {
    switch (ui.language) {
      case 'zh-hans': {
        return `深入`
      }

      default: {
        return 'Drill Down'
      }
    }
  }

  @computed get addNotes() {
    switch (ui.language) {
      case 'zh-hans': {
        return `添加注释...`
      }

      default: {
        return 'Enter Notes...'
      }
    }
  }

  @computed get assignAsArticleCandidate () {
    switch (ui.language) {
      default: {
        return 'Assign as Article Candidate'
      }
    }
  }

  @computed get openInPLM() {
    switch (ui.language) {
      case 'zh-hans': {
        return `在PLM中打开`
      }

      default: {
        return 'Open in PLM'
      }
    }
  }

  @computed get page() {
    switch (ui.language) {
      case 'zh-hans': {
        return `页面`
      }

      default: {
        return 'Page'
      }
    }
  }

  @computed get first() {
    switch (ui.language) {
      case 'zh-hans': {
        return `首先`
      }

      default: {
        return 'First'
      }
    }
  }

  @computed get next() {
    switch (ui.language) {
      case 'zh-hans': {
        return `后一个`
      }

      default: {
        return 'Next'
      }
    }
  }

  @computed get previous() {
    switch (ui.language) {
      case 'zh-hans': {
        return `前一个`
      }

      default: {
        return 'Previous'
      }
    }
  }

  @computed get last() {
    switch (ui.language) {
      case 'zh-hans': {
        return `最后`
      }

      default: {
        return 'Last'
      }
    }
  }

  @computed get sort() {
    switch (ui.language) {
      case 'zh-hans': {
        return `分类`
      }

      default: {
        return 'Sort'
      }
    }
  }

  @computed get pdfView() {
    switch (ui.language) {
      case 'zh-hans': {
        return `PDF视图`
      }

      default: {
        return 'PDF View'
      }
    }
  }

  @computed get syncCollectionFolder() {
    switch (ui.language) {
      case 'zh-hans': {
        return `同步系列文件夹`
      }

      default: {
        return 'Sync Collection Folder'
      }
    }
  }

  @computed get unLinkFromPLM() {
    switch (ui.language) {
      case 'zh-hans': {
        return `取消与PLM链接`
      }

      default: {
        return 'Unlink from PLM'
      }
    }
  }

  @computed get linkToPLM() {
    switch (ui.language) {
      case 'zh-hans': {
        return `链接到PLM`
      }

      default: {
        return 'Link to PLM'
      }
    }
  }

  @computed get manage() {
    switch (ui.language) {
      case 'zh-hans': {
        return `管理`
      }

      default: {
        return 'Manage'
      }
    }
  }

  @computed get offline() {
    switch (ui.language) {
      case 'zh-hans': {
        return `离线`
      }

      default: {
        return 'Offline'
      }
    }
  }

  @computed get requireMerchCategory() {
    switch (ui.language) {
      case 'zh-hans': {
        return `需要商品企划类别和季节`
      }

      default: {
        return 'Requires Merch Category and Season'
      }
    }
  }

  @computed get exportExcel() {
    switch (ui.language) {
      case 'zh-hans': {
        return `??`
      }

      default: {
        return 'Export to Excel'
      }
    }
  }

  @computed get export() {
    switch (ui.language) {
      case 'zh-hans': {
        return `??`
      }

      default: {
        return 'Export'
      }
    }
  }

  @computed get cancel() {
    switch (ui.language) {
      case 'zh-hans': {
        return `??`
      }

      default: {
        return 'Cancel'
      }
    }
  }

  @computed get filterFromSelection() { 
    return {'zh-hans': '从选择中过滤'}[ui.language] ?? 'Filter from Selection'
  }

  @computed get exportImageSizes() { 
    return {'zh-hans': ''}[ui.language] ?? 'Preparing images to .zip, please choose a file size:'
  }

  @computed get imageSizes() { 
    return {'zh-hans': ''}[ui.language] ?? 'Image Sizes'
  }
  
  @computed get syncIndicator() {
    switch (ui.language) {
      case 'zh-hans': {
        return {
          empty: '??',
          progress: '??',
          stop: '??',
          lastSync: '??',
          syncingCollection: '??',
          syncCollection: '??',
          sync: '??',
          syncingIndex: '??',
          syncIndex: '??',
          never: '??'
      }
      }

      default: {
        return {
          empty: '',
          progress: 'Progress',
          stop: 'Stop',
          lastSync: 'Last Sync',
          sync: 'Sync',
          syncingCollection: 'Syncing Collection',
          syncCollection: 'Sync Collection',
          syncingIndex: 'Syncing Workspace',
          syncIndex: 'Sync Workspace',
          never: 'Never'
      }
      }
    }
  }
  deleteTagMsg = computedFn((name, count, catalogItemName) => {
    switch (ui.language) {
      case 'zh-hans': {
        return `??`
      }

      default: {
        return count === 0 ? `Are you sure want to delete '${name}'?` : `'${name}' is assigned to ${count} ${pluralize(catalogItemName, count)}, are you sure you want to delete it?`
      }
    }
  })
  validPublishCountTitle = computedFn((validItems: number, totalItems: number) => {
    switch (ui.language) {
      default: {
        return validItems === totalItems ? '' : `${validItems} valid out of ${totalItems}`
      }
    }
  })
  validPublishCount = computedFn((validItems: number, totalItems: number) => {
    switch (ui.language) {
      default: {
        return validItems === totalItems ? '' : `${validItems} / ${totalItems}`
      }
    }
  })

  @computed get syncNotRunning() {
    switch (ui.language) {
      case 'zh-hans':
        default: {
        return 'No Sync in Progress'
      }
    }
  }

  catalogViewModeFor = (viewMode: CatalogViewMode) => {
    switch (viewMode) {
      case 'card':
        switch (ui.language) {
          case 'zh-hans':
          default: {
            return 'Card View'
          }
        }

      case 'table': {
        return 'Table View'
      }

      case 'report': {
        return 'Report View'
      }

      default:
        return `${_.capitalize(viewMode)} View`
    }

  }

  @computed get devOnly() {
    return 'Dev-Only'
  }

  @computed get expandRow() {
    switch (ui.language) {
      case 'zh-hans':
        default: {
        return 'Expand Row Inline'
      }
    }
  }

  @computed get collapseRow() {
    switch (ui.language) {
      case 'zh-hans':
        default: {
        return 'Collapse Row'
      }
    }
  }

  @computed get assortment() {
    const {deploymentConfig: {settings}} = deployments

    switch (ui.language) {
      case 'zh-hans':
      default: {
        return settings?.assortments?.assortmentNoun ?? 'Assortment'
      }
    }
  }

  @computed get assortments() { return pluralize(this.assortment)}
}

export const strings = new StringsStore()


// WEBPACK FOOTER //
// ./src/stores/StringsStore.ts